var {AmpersandView} = require('catalog/libs');

/**
 * Product Catalog View for each Compare Tray Item
 */
module.exports = AmpersandView.extend({

    render: function(opts) {
        this.renderCollection(this.collection, function(options) {
            return new CompareTrayItemView(options);
        }, this.el, opts);
        return this;
    }

});

var CompareTrayItemView = AmpersandView.extend({

    bindings: {
        'model.prodname': {
            type: 'text',
            selector: '.catalog-compare-tray-label span'
        },
        'model.active': {
            type: 'booleanClass',
            selector: '.catalog-compare-tray-item-content',
            name: 'active'
        },
        'model.removed': [{
            type: 'booleanClass',
            selector: 'li',
            name: 'removed'
        },
        {
            type: 'booleanClass',
            selector: '.catalog-compare-tray-item-content',
            name: 'removed'
        }],
        'model.added': {
            type: function (el, value) {
                if (value) {
                    setTimeout(function() {
                        el.classList.add('added');
                    }, 50); //without a slight delay, no css animation
                }
            },
            selector: '.catalog-compare-tray-item-content'
        },
        'model.i18n.remove': {
            type: 'text',
            selector: '.catalog-compare-tray-remove .sr-only'
        },
        'model.i18n.new': {
            type: 'text',
            selector: '.product-status.new-product'
        },
        'model.i18n.updated': {
            type: 'text',
            selector: '.product-status.updated-product'

        },
        'model.produrl': {
            type: 'attribute',
            selector: '.catalog-compare-tray-link',
            name: 'href'
        },
		'model.updated': {
			type: 'toggle',
			selector: '.product-status.updated-product'
		},
		'model.new': {
			type: 'toggle',
			selector: '.product-status.new-product'
		}
    },

    /**
     * template
     */
    template: function() {
        return require('./hpe.catalog.comparetray.item.template.tpl');
    },

    /**
     * event bindings
     */
    events: {
        'click .catalog-compare-tray-remove': 'onRemoveClick',
        'transitionend li': 'onTransitionEnd'
    },

    /**
     * handle clicks to the remove button, remove the compare item
     * @param  {object} e event object
     */
    onRemoveClick: function(e) {
        e.preventDefault();
        this.model.removed = true;

    },

    /**
     * handle transition end event on compare item
     * animation enabled by setting ampersand bits -- ensure order of bit setting happens correctly
     * to remove items after animations complete
     * @param  {object} e event object
     */
    onTransitionEnd: function(e) {

        //if target has transitioned in with added class, remove that class
        if (e.target.classList.contains('added')) {
            this.model.active = true;
            this.model.added = false;
            e.target.classList.remove('added');

        //finish animation before removing element:
        //width property transition followed by remove call
        //note: mobile view does not animate, so remove() called manually elsewhere as needed
        } else if (e.propertyName === 'width') {
            this.model.remove();
        }
    }

});

